import moment = require('@tableau/metrics-engine/node_modules/moment');
import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';
import _ = require('underscore');
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import { WebHttpClientWithErrorToastInstance } from '~src/httpClient/WebHttpClientWithErrorToast';

import { GetResourceGovernanceServerSettingsRequest, IGetResourceGovernanceServerSettingsResult, IResourceGovernanceServerSettings } from '../types/ResourceGovernance';
import { openResourceGovernanceEditDefaultLimitsDialog } from './ResourceGovernanceEditDefaultLimitsDialog';
import { SchedulesGovernanceLimitsCard } from './SchedulesGovernanceLimitsCard';

export const LIMITS_BUTTON_TEST_ID = 'default-limits';

export interface SchedulesGovernanceLimitsSectionProps {
  isFirstRun: boolean;
}

export class SchedulesGovernanceLimitsSection extends React.PureComponent<SchedulesGovernanceLimitsSectionProps, IResourceGovernanceServerSettings>{
  public componentDidMount() {
    WebHttpClientWithErrorToastInstance.sendRequest(new GetResourceGovernanceServerSettingsRequest())
      .then((result: IGetResourceGovernanceServerSettingsResult) => {
        if (result.errors?.length) {
          ToasterService.instance.pop({ type: ToastType.Error, text: Messages.errorUnknown() });
          return;
        }

        this.setState({ ...result});
      });
  }

  public render() {
    const buttonText = this.props.isFirstRun
      ? Messages.resourceGovernanceSetDefaultTitle()
      : Messages.resourceGovernanceEditDefaultTitle();
    return <>
      {<SchedulesGovernanceLimitsCard {...this.state} />}
      <ButtonWidget
        testId={LIMITS_BUTTON_TEST_ID}
        buttonType={ButtonType.Primary}
        children={buttonText}
        style={{ marginTop: 12, marginBottom: 22 }}
        onClick={() => openResourceGovernanceEditDefaultLimitsDialog({
          isFirstRun: this.props.isFirstRun,
          updateState: settings => this.setState(settings) // Avoids trying to invoke this in the wrong context
        })}
      />
    </>;
  }
}
